import {Box, Icon, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

export function MapPreviewPlaceholder() {
  return (
    <Box height="100%" backgroundColor="palettes.neutral.10.100" padding={6}>
      <VStack height="100%" align="center" justify="center" spacing={3}>
        <Icon value="maps/directions_car" size={10} color="palettes.neutral.60.100" />
        <Text align="center" color="secondary">
          {i18n.t('page.sourcing.map.selectVehicleForPreview')}
        </Text>
      </VStack>
    </Box>
  );
}
